<template>
  <div class="group-box">
    <div class="box-title">
      <div class="title f-16 f-c-999">分组</div>
      <div class="btn">
        <a-button class="btn-primary" @click="openAdd">创建新分组</a-button>
      </div>
    </div>
    <div v-for="(item, index) in groupListData" :key="index" class="box-list">
      <div class="list-lef">
        <div class="lef-name f-c-000">{{ item.name }}</div>
        <div class="lef-num">{{ item.num }}套</div>
      </div>
      <div class="list-rig f-20 f-c-999">
        <edit-outlined
            style="margin-right: 15px; cursor: pointer"
            @click="openEdit(item)"
        />
        <delete-outlined style="cursor: pointer" @click="handleDel(item)"/>
      </div>
    </div>
  </div>

  <a-modal v-model:visible="visibleAdd" :title="modalTitle" @ok="handleAddEdit">
    <a-form ref="formRef" :model="form" :rules="rules">
      <a-form-item label="组名：" name="names">
        <a-input
            v-model:value="form.names"
            placeholder="请输入组名"
            style="width: 100%"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import {DeleteOutlined, EditOutlined, ExclamationCircleOutlined,} from "@ant-design/icons-vue";
import {createVNode, onMounted, reactive, toRefs} from "vue";
import {groupAdd, groupDel, groupEdit, groupList} from "@/api/api";
import {message, Modal} from "ant-design-vue";

export default {
  components: {
    EditOutlined,
    DeleteOutlined,
  },
  setup() {
    const list = reactive({
      groupListData: [],
      getGroupList() {
        groupList({
          start: 0,
          limit: 99,
        }).then((res) => {
          list.groupListData = res.data;
        });
      },
      openAdd() {
        modal.form = {
          names: "",
        };
        if (modal.formRef) {
          modal.formRef.resetFields();
        }
        modal.visibleAdd = true;
        modal.modalTitle = "添加新分组";
      },
      openEdit(item) {
        if (modal.formRef) {
          modal.formRef.resetFields();
        }
        modal.form.id = item.id;
        modal.form.names = item.name;
        modal.visibleAdd = true;
        modal.modalTitle = "编辑分组";
      },
      // 删除账号
      handleDel(item) {
        Modal.confirm({
          title: "是否删除分组？",
          content: "删除后无法恢复，分组内的房间将自动移出",
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            groupDel({id: item.id}).then((res) => {
              message.success(res.msg);
              list.getGroupList();
            });
          },
        });
      },
    });

    const modal = reactive({
      visibleAdd: false,
      modalTitle: "",
      form: {
        names: "",
      },
      formRef: "",
      rules: {
        names: [
          {
            required: true,
            message: "请输入组名",
            trigger: "blur",
          },
        ],
      },
      handleAddEdit() {
        modal.formRef.validate().then(() => {
          if (modal.form.id) {
            groupEdit({
              name: modal.form.names,
              id: modal.form.id,
            }).then((res) => {
              message.success(res.msg);
              modal.visibleAdd = false;
              list.getGroupList();
            });
          } else {
            groupAdd(modal.form).then((res) => {
              message.success(res.msg);
              modal.visibleAdd = false;
              list.getGroupList();
            });
          }
        });
      },
    });

    onMounted(() => {
      list.getGroupList();
    });

    return {
      ...toRefs(modal),
      ...toRefs(list),
    };
  },
};
</script>

<style lang="scss" scoped>
.group-box {
  background-color: #fff;
  width: 50%;
  box-shadow: 0 0 5px #99999933;

  .box-title {
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    border-bottom: 1px solid #f2f2f2;

    .title {
    }

    .btn {
    }
  }

  .box-list {
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .list-lef {
      .lef-name {
        margin-bottom: 5px;
      }

      .lef-num {
      }
    }

    .list-rig {
      display: flex;
    }
  }
}
</style>